import { Option } from '../../types';
import {
  DefaultFetchError,
  FetchGet,
  useFetchGet,
} from '../fetch';
import { QuestionUserType } from './questions';

export interface QuestionStatisticParams {
    subCategoryId: string;
}

export interface QuestionItemData {
  id: string;
  question: string;
  userType?: QuestionUserType;
  numbers: { valueofChoice: string, value: number }[];
}

export interface IQuestionStatistic {
  list: {
    legend: Option<string, string>[];
    data: QuestionItemData[],
  }[]
}

export const useQuestionStatistic = (subCategoryId?: string): FetchGet<
    IQuestionStatistic,
    QuestionStatisticParams,
    DefaultFetchError
> => (
  useFetchGet('statistics/for-each-question', {
    autoStart: !!subCategoryId,
    startStateLoading: false,
    config: {
      params: subCategoryId ? { subCategoryId } : undefined,
    },
  })
);
